const state = {
  employersAndRoleList: [],
  employerDialog: {
    status: false,
    action: 'add',
    employerId: null,
  },
  employerCode: '',
  employerCnpj: '',
  employerSocialName: '',
  employerContacts: null,
};

export default state;
